export default "__VITE_ASSET__4e112f0f__"